import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { businessApi } from "../api/api";

interface PermissionContextType {
  permissionLevel: string | null;
}

export const PermissionContext = createContext<
  PermissionContextType | undefined
>(undefined);

interface PermissionProviderProps {
  children: ReactNode;
}

export const PermissionProvider: React.FC<PermissionProviderProps> = ({
  children,
}) => {
  const [permissionLevel, setPermissionLevel] = useState<string | null>(null);

  const fetchPermissionLevel = async () => {
    try {
      const response = await businessApi.getPermissionLevel();
      setPermissionLevel(response.data.permission_level);
    } catch (err) {
      console.error("Error fetching permission level:", err);
      setPermissionLevel(null);
    }
  };

  useEffect(() => {
    if (!permissionLevel) {
      fetchPermissionLevel();
    }
  }, [permissionLevel]);

  const value: PermissionContextType = {
    permissionLevel,
  };

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = (): PermissionContextType => {
  const context = useContext(PermissionContext);
  if (context === undefined) {
    throw new Error("usePermissions must be used within a PermissionProvider");
  }
  return context;
};
